import { defineWorkflow } from './workflow-builder'

/** WF-WIP-01 (WIP Leftover Return) — TL 12B WF-WIP-01 §1–§8 [C]. */
export const WF_WIP = defineWorkflow({
  no: 7,
  code: 'WF-WIP-01',
  name: 'WIP Leftover Return Workflow',
  entity: 'wip_return',
  statuses: [
    ['WIP_DRAFT', 'Draft', true, false, '#64748B', 'Draft pengembalian sisa material oleh Produksi'],
    [
      'WIP_PENDING_CHECK',
      'Menunggu Pengecekan',
      false,
      false,
      '#F59E0B',
      'Material tiba di pos RM, menunggu verifikasi Admin'
    ],
    [
      'WIP_CHECKED',
      'Disetujui & Dicetak Label',
      false,
      false,
      '#06B6D4',
      'Fisik lolos verifikasi, label baru tercetak, tugas putaway dibuat'
    ],
    ['WIP_PUTAWAY', 'In Storage', false, true, '#10B981', 'Material WIP telah ditaruh di rak penyimpanan'],
    ['WIP_REJECTED', 'Ditolak', false, true, '#EF4444', 'Pengembalian ditolak karena NG / kemasan tidak standar']
  ],
  actors: [
    ['ACT_WIP_PRODUKSI', 'Tim Produksi', 'tim_produksi', { created_by: { _eq: '$CURRENT_USER.id' } }],
    ['ACT_WIP_ADMIN_RM', 'Admin WH RM', 'admin_wh_rm', null],
    ['ACT_WIP_OP_RM', 'Operator WH RM', 'operator_wh_rm', null],
    ['ACT_WIP_SPV_RM', 'WH RM Supervisor', 'wh_rm_supervisor', null]
  ],
  components: [
    ['CMP_WIP_SUBMIT', 'Tombol Kirim Laporan WIP', 'ACTION', { color: '#3B82F6', variant: 'primary' }],
    ['CMP_WIP_ACCEPT', 'Tombol Terima & Cetak Label', 'ACTION', {}],
    ['CMP_WIP_REJECT', 'Tombol Tolak Pengembalian', 'ACTION', {}],
    ['CMP_WIP_PUTAWAY_DONE', 'Tombol Konfirmasi Putaway', 'ACTION', {}],
    ['CMP_WIP_PANEL_HEADER', 'Panel Header WIP Return', 'PANEL', {}],
    ['CMP_WIP_PANEL_ITEMS', 'Panel Detail Kemasan WIP', 'PANEL', {}]
  ],
  actions: [
    ['ACT_WIP_SEND', 'WIP_DRAFT', 'WIP_PENDING_CHECK', 'CMP_WIP_SUBMIT', false, false, null],
    ['ACT_WIP_CHECK_OK', 'WIP_PENDING_CHECK', 'WIP_CHECKED', 'CMP_WIP_ACCEPT', false, false, null],
    ['ACT_WIP_REJECT_NG', 'WIP_PENDING_CHECK', 'WIP_REJECTED', 'CMP_WIP_REJECT', true, true, null],
    [
      'ACT_WIP_STORE',
      'WIP_CHECKED',
      'WIP_PUTAWAY',
      'CMP_WIP_PUTAWAY_DONE',
      false,
      false,
      { is_stored: true, stored_at: '$NOW' }
    ]
  ],
  eligibility: [
    ['ACT_WIP_SEND', 'ACT_WIP_PRODUKSI'],
    ['ACT_WIP_CHECK_OK', 'ACT_WIP_ADMIN_RM'],
    ['ACT_WIP_REJECT_NG', 'ACT_WIP_ADMIN_RM'],
    ['ACT_WIP_STORE', 'ACT_WIP_OP_RM']
  ],
  panels: [
    ['CMP_WIP_PANEL_HEADER', 'WIP_DRAFT', 'write', 'ACT_WIP_PRODUKSI'],
    ['CMP_WIP_PANEL_HEADER', 'WIP_PENDING_CHECK', 'read', null],
    ['CMP_WIP_PANEL_HEADER', 'WIP_PUTAWAY', 'read', null],
    ['CMP_WIP_PANEL_ITEMS', 'WIP_DRAFT', 'write', 'ACT_WIP_PRODUKSI'],
    ['CMP_WIP_PANEL_ITEMS', 'WIP_PENDING_CHECK', 'write', 'ACT_WIP_ADMIN_RM'],
    ['CMP_WIP_PANEL_ITEMS', 'WIP_PUTAWAY', 'read', null]
  ],
  emailStatuses: ['WIP_PENDING_CHECK', 'WIP_REJECTED']
})

export type WipStatusCode = (typeof WF_WIP.spec.statuses)[number][0]
export type WipActorCode = (typeof WF_WIP.spec.actors)[number][0]
export type WipActionName = (typeof WF_WIP.spec.actions)[number][0]
export const buildWorkflowWipSeed = WF_WIP.build
